const { Component: r } = wp.element;
class o extends r {
  constructor(e) {
    super(e), this.state = { error: null, errorInfo: null };
  }
  componentDidCatch(e, t) {
    this.setState({
      error: e,
      errorInfo: t
    });
  }
  render() {
    return this.state.errorInfo ? /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("h2", null, "Something went wrong. Please contact the admin with this error message:"), this.state.error && this.state.error.toString(), /* @__PURE__ */ React.createElement("br", null), this.state.errorInfo.componentStack) : this.props.children;
  }
}
export {
  o as ErrorBoundary
};
